import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button, Util } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { BannerTooltip } from '../BannerTooltip/BannerTooltip.js';
import LazyPicture from '../LazyPicture/LazyPicture.js';

const PromotionBannersItem = ({ image , mobileImage , link , title , text , fullWidth =false , tooltip ,  })=>{
    if (!image) {
        console.warn(`Cannot render PromotionBanner: missing image`);
        return null;
    }
    return /*#__PURE__*/ React.createElement("a", {
        className: classnames('promotion-banners-item', {
            'promotion-banners-item--overlay': title || text,
            'promotion-banners-item--full-width': fullWidth && title && text
        }),
        href: link.url
    }, image && image.url && /*#__PURE__*/ React.createElement(LazyPicture, {
        className: "promotion-banners-item__image",
        image: image,
        mobileImage: mobileImage
    }), /*#__PURE__*/ React.createElement("div", {
        className: "promotion-banners-item__body-outer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "promotion-banners-item__body"
    }, (title || text) && /*#__PURE__*/ React.createElement("div", {
        className: "promotion-banners-item__content"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "small",
        className: "promotion-banners-item__title"
    }, title), text && /*#__PURE__*/ React.createElement("p", {
        className: "promotion-banners-item__description"
    }, text)), link && link.label && /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        size: "custom",
        caption: link.label,
        className: "promotion-banners-item__button"
    }, Util.createButtonStyles(link.style)))), tooltip && /*#__PURE__*/ React.createElement(BannerTooltip, {
        className: "promotion-banners-item__tooltip",
        tooltip: tooltip
    })));
};

export { PromotionBannersItem as default };
//# sourceMappingURL=PromotionBannersItem.js.map
